import React, { useEffect, useState } from "react";
import { Breadcrumb, Input, Space, Table, Popconfirm, Row, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import { debounce } from "lodash";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import "react-confirm-alert/src/react-confirm-alert.css";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";
import { authUserData } from "../../utils/Helper";
const { Search } = Input;

const ActivityLogList = () => {
  const { t } = useTranslation();

  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requestedDemoList, setRequestedDemoList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });

  useEffect(() => {
    const getActivityLogList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("activity-log/get-activity-log/", state);

        if (apiResponse.data.results.success) {
          setRequestedDemoList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_activity_log_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getActivityLogList();
  }, [state, reload, t]);

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "country" && sortOrder === "ascend") {
      sortingEnumKey = "country";
    }
    if (sortField === "country" && sortOrder === "descend") {
      sortingEnumKey = "-country";
    }
    if (sortField === "detail" && sortOrder === "ascend") {
      sortingEnumKey = "detail";
    }
    if (sortField === "detail" && sortOrder === "descend") {
      sortingEnumKey = "-detail";
    }
    if (sortField === "ip_address" && sortOrder === "ascend") {
      sortingEnumKey = "ip_address";
    }
    if (sortField === "ip_address" && sortOrder === "descend") {
      sortingEnumKey = "-ip_address";
    }
    if (sortField === "log_time" && sortOrder === "ascend") {
      sortingEnumKey = "log_time";
    }
    if (sortField === "log_time" && sortOrder === "descend") {
      sortingEnumKey = "-log_time";
    }

    return sortingEnumKey;
  };

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Person Name",
      dataIndex: "person_name",
      sorter: true,
      key: "person_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      key: "email",
    },
    {
      title: "Mobile",
      dataIndex: "phone",
      render: (phone) => <>+{phone} </>,
      sorter: true,
      key: "phone",
    },
    {
      title: "Event",
      dataIndex: "event_type",
      sorter: true,
      key: "event_type",
    },

    {
      title: "Detail",
      dataIndex: "details",
      sorter: true,
      key: "detail",
    },
    {
      title: "Date/Time",
      dataIndex: "changed_at",
      sorter: true,
      key: "changed_at",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      sorter: true,
      key: "ip_address",
    },
    // {
    //   title: "Log Time",
    //   dataIndex: "log_time",
    //   sorter: true,
    //   key: "log_time",
    // },
  ];

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("request-demo-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("activity_log_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_archive_activity_log"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
      if (value) {
          setState({
              ...state,
              search: value,
          });
      } else {
          const { search, ...newState } = state; // Remove 'search' key from state
          setState(newState);
      }
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const colors = ["#094E8F"];
  return (
    <>
     
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Track and review all activity within your procurement system.
                  </span>
                }
              >
                <h3>{t("pl_activity_log")}</h3>
              </Tooltip>

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("pl_activity_log")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>
                </Space>
              </div>

              {selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive()}
                >
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                </Popconfirm>
              )}
              {/* {authUserData()?.permission.includes("company|delete_company") && (
              <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/activity-log/archive" className="Archiveicon">
                  <Archiveicon />
                </Link>
              </Tooltip>
                )} */}
            </Space>
          </div>
        </div>
    
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
        {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("pl_activity_log")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_archive")}
                />
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/activity-log/archive" className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Col> */}
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: 1500,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={requestedDemoList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};

export default ActivityLogList;
